import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import "./i18n/config"; // Initialize i18n
import App from "./App";
import LoginPage from "./features/auth/pages/LoginPage";
import RegisterDemo from "./pages/RegisterDemo";
import ResetPassword from "./pages/ResetPassword";
import AdminDashboard from "./pages/AdminDashboard";
import UserManagement from "./pages/admin/UserManagement";
import UserActivityTimeline from "./pages/admin/UserActivityTimeline";
import CreateUser from "./pages/admin/CreateUser";
import InviteUser from "./pages/admin/InviteUser";
import CompanyManagement from "./pages/admin/CompanyManagement";
import AuditLogs from "./pages/admin/AuditLogs";
import UsageLimits from "./pages/admin/UsageLimits";
import SurveyResponses from "./pages/admin/SurveyResponses";
import PromptManagement from "./PromptManagement";
import Logs from "./Logs";
import SearchHistory from "./pages/SearchHistory";
import SearchDetails from "./pages/SearchDetails";
import ProtectedRoute, { AdminRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./features/auth/context/AuthContext";
import { UsageProvider } from "./contexts/UsageContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <UsageProvider>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register-demo" element={<RegisterDemo />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Protected routes - Require authentication */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <App />
                </ProtectedRoute>
              }
            />

            {/* Search History - Available to all authenticated users */}
            <Route
              path="/search-history"
              element={
                <ProtectedRoute>
                  <SearchHistory />
                </ProtectedRoute>
              }
            />

            {/* Search Details - Available to all authenticated users */}
            <Route
              path="/search-history/:searchId"
              element={
                <ProtectedRoute>
                  <SearchDetails />
                </ProtectedRoute>
              }
            />

            {/* Admin routes - Require admin privileges */}
            <Route
              path="/admin/settings"
              element={
                <AdminRoute>
                  <PromptManagement />
                </AdminRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/query-logs"
              element={
                <AdminRoute>
                  <Logs />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <AdminRoute>
                  <UserManagement />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/user-activity"
              element={
                <AdminRoute>
                  <UserActivityTimeline />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/users/new"
              element={
                <AdminRoute>
                  <CreateUser />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/users/invite"
              element={
                <AdminRoute>
                  <InviteUser />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/companies"
              element={
                <AdminRoute>
                  <CompanyManagement />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/audit-logs"
              element={
                <AdminRoute>
                  <AuditLogs />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/usage-limits"
              element={
                <AdminRoute>
                  <UsageLimits />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/survey-responses"
              element={
                <AdminRoute>
                  <SurveyResponses />
                </AdminRoute>
              }
            />
          </Routes>
        </Router>
      </UsageProvider>
    </AuthProvider>
  </React.StrictMode>,
);
